import Toast from 'react-native-toast-message';

/**
 * Global Toast Utility
 * Provides a standardized interface for triggering temporary notification overlays 
 * throughout the application.
 */
export const showToast = (type: 'success' | 'error', text1: string, text2?: string) => {
    /**
     * Executes the toast display with pre-configured duration and positioning logic.
     */
    Toast.show({
        type,
        text1,
        text2,
        // Success: 2.5s — enough to read a short confirmation.
        // Error: 6s — backend error messages can be multi-sentence; user must be
        // able to read the full response before it auto-dismisses.
        visibilityTime: type === 'success' ? 3000 : 4000,
        autoHide: true,
        topOffset: 60,
        // Allow up to 5 lines so long backend messages (validation errors,
        // conflict descriptions, etc.) are never cut off mid-sentence.
        ...(text2 ? { text2NumberOfLines: 5 } as any : {}),
    });
};